export const leadInputText = (choice: {
    nome_lead: string;
}) => `${choice.nome_lead}`;
